import { render, staticRenderFns } from "./shiftRejected.vue?vue&type=template&id=684306d3&"
import script from "./shiftRejected.vue?vue&type=script&lang=js&"
export * from "./shiftRejected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports